import React, { useState, useEffect, useMemo } from "react";
import Navbar from "../../../../components/Navbar";
import SideBar from "../../../../components/SideBar";
import { Table } from "react-bootstrap";
import Dynamic_PR_table from "./Dynamic_PR_table";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { FaSpinner } from "react-icons/fa";


const customStyle = {
  control: (provided, state) => ({
    ...provided,
    height: "64px",
    overflow: "scroll",
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: "white",
    ":hover": {
      backgroundColor: "red",
      color: "white",
    },
  }),
};

const EmployeesSelection = () => {

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Employee Selection"))
  }, [])

  const columns = {
    EmpName: { text: " Employee", align: "left", width: "400px", visible: true },
    // ContractorsName : { text: " Employee", align: "left", width: "400px" },
    SkillName: { text: "Skill", align: "left", visible: true },
    SubSkillName: { text: "SubSkill", align: "left", visible: true },
    Project: { text: "Current Project", align: "left", visible: true },
    ClientName: { text: "Client Name", align: "end", visible: true },
    Billable: { text: "Billable", align: "center", visible: true },
    EndDate: { text: "Project End Date", align: "center", visible: true },
    EXP: { text: " Relevent Exp.", align: "center", visible: true },
    Designation: { text: "Current Designation", align: "start", visible: true },
  };
  const defaultColumns = {
    ContractorsName: true,
    EmpName: true,
    SkillName: true,
    SubSkillName: true,

    Project: true,

    ClientName: true,
    Billable: true,
    EndDate: true,
    EXP: true,
    Designation: true,
  };

  const [typeValue, setTypeVlaue] = useState({ value: 1, label: "Employee" });
  const [typeValue2, setTypeVlaue2] = useState({ value: 1, label: "Employee" });

  const ContratorColumns = {
    // EmpName: { text: " Employee", align: "left", width: "400px" },    
    ContractorsName: { text: " Employee", align: "left", width: "400px" },
    Skill: { text: "Skill", align: "left" },
    TechnologyID: { text: "SubSkill", align: "left" },
    Billable: { text: "Billable", align: "center" },
    RelevantExp: { text: " Relevent Exp.", align: "center" },
    Phone: { text: "Phone", align: "left" },

  };
  const defaultContratorColumns = {
    ContractorsName: true,
    // EmpName: true,
    Skill: true,
    TechnologyID: true,

    RelevantExp: true,

    Phone: true,
    Billable: true,


  };


  const [skill_id, setSkillIDFromApi] = useState()

  const { id } = useParams();

  const navigate = useNavigate();

  const [employeeSelectionList, setEmployeeSelectionList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");




  const [skillSetOptions, setSkillSetOptions] = useState([]);
  const [subSkillOptions, setSubSkillOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    fetchSkills(id);
  }, [id]);


  const [apiStatus, setApiStatus] = useState(undefined)
  const fetchSkills = async (id) => {
    setApiStatus(undefined)
    try {
      // Construct the query parameters
      const queryParams = new URLSearchParams({
        P_Id: id || 0,
        searchString: skill_id || 0,
        typeofemployee: typeValue.value // Include the typeofemployee parameter here
      });

      // Make the GET request
      const response = await GetServiceCaller(
        `${API_URL}employee-selection?${queryParams.toString()}`
      );

      setApiStatus(response?.status)
      // Process the response
      const cleanedData = response.data.headers;
      console.log("cleanedData", response.data.selected_skills);

      setSkillIDFromApi(response.data.selected_skills)
      setEmployeeSelectionList(cleanedData);

      const skillData = response.data.skills_and_subskills;
      const options_skills = skillData.map((skill) => ({
        value: skill.ID,
        label: skill.Name || skill.SubSkill,
      }));
      console.log("=========>", options_skills);

      setSkillSetOptions(options_skills);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };


  const [selectedSkill, setSelectedSkill] = useState([]);


  useEffect(() => {
    if (skill_id) {
      const splitSkill = skill_id.split(",");
      console.log("splitSkill", splitSkill);

      const defaultSkill = splitSkill.map((element) =>
        skillSetOptions.find((o) => o.value === Number(element))
      );

      console.log("defaultSkill", defaultSkill);
      setSelectedSkill(defaultSkill);
    }
  }, [skill_id, skillSetOptions]);



  const handleSkillFilter = (selected) => {

    setSelectedSkill(selected);

  };
  ;

  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});
  const [selectedResources, setSelectedResources] = useState([]);
  const [selectedAllResources, setSelectedAllResources] = useState([]);


  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);

    const newSelectedItems = checked
      ? employeeSelectionList.map((item) => item)
      : [];

    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = { ...prevSelectedItems };
      employeeSelectionList.forEach((item) => {
        updatedSelectedItems[item.EmployeeID] = checked;
      });
      return updatedSelectedItems;
    });

    setSelectedResources(newSelectedItems);
  };

  let selected_items = [];

  const handleCheckboxChange = (e, id, item) => {
    const isChecked = e.target.checked;

    setSelectedResources((prevSelectedResources) => {
      if (isChecked) {
        return [...prevSelectedResources, item];
      } else {
        return prevSelectedResources.filter(
          (resource) => resource.EmployeeID ? resource.EmployeeID !== id : resource.ID !== id
        );
      }
    });
    setSelectedItems((prevSelectedItems) => ({
      ...prevSelectedItems,
      [id]: isChecked,
    }));

  };

  const handleSubmit = async (e) => {
    // e.preventDefaults();
    setLoading(true);
    setSubmitLoading(true)


   if (selectedResources.length === 0) {
  toast.error("Please Select The Resource");
  setLoading(false);
  setSubmitLoading(false);
  return;
}

    try {
      let response;

      response = await PostServiceCaller(
        `${API_URL}selected-employee`,
        {
          RequirementId: id,
          Employees: selectedResources
            .map((ele) => ele.ID ? ele.ID : ele.EmployeeID)
            .join(","),
          typeofemployee: typeValue.value
        },
        "post"
      );
      setSubmitLoading(false)
      if (response.status === 200) {
        toast.success("Data submitted successfully ");

        setTimeout(() => {
          navigate(
            `/customer-requirement/edit/${id}/${selectedResources
              .map((ele) => ele.ID ? ele.ID : ele.EmployeeID)
              .join(",")}`
          );

        }, 2000);
      } else {

        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
        console.error("Response data:", response.data);
      }

    } catch (error) {
      setSubmitLoading(false)
      console.error("Error while submitting data:", error);
      if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error, {
          position: "top-right",
        });
        console.error("Server responded with status:", error.response.status);
        console.error("Response data:", error.response.data);
      }
    } finally {
      setLoading(false);
      setSubmitLoading(false)
    }













  };

  const handleGetData = async () => {
    setApiStatus(undefined)
    try {
      // Construct the query parameters
      const queryParams = new URLSearchParams({
        P_Id: id || 0,
        searchString: selectedSkill.length > 0
          ? selectedSkill.map((ele) => ele.value).join(",")
          : 0,
        typeofemployee: typeValue2.value // Include the typeofemployee parameter here
      });

      // Make the GET request
      const response = await GetServiceCaller(
        `${API_URL}employee-selection?${queryParams.toString()}`
      );
      setApiStatus(response?.status)
      // Process the response
      const cleanedData = response.data.headers;
      console.log("cleanedData", cleanedData);
      setEmployeeSelectionList(cleanedData);
      if (response.status === 200) {
        setTypeVlaue(typeValue2)
        setSelectedResources([])
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };


  const typeOptions = [
    // { value: "", label: "Select" },
    { value: 1, label: "Employee" },
    { value: 2, label: "Contractor" },
  ];


  const dynamicColumns = useMemo(() => {
    if (typeValue.value === 1) {
      return {
        columns: columns, // Employee-specific columns
        defaultColumns: defaultColumns,
      };
    } else {
      return {
        columns: ContratorColumns, // Contractor-specific columns
        defaultColumns: defaultContratorColumns,
      };
    }
  }, [typeValue]);
  console.log("typeValue", typeValue);
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mb-2">
            <div className="col-md-3">
              <label class="form-label">
                Skills <span className="text-danger me-2">*</span>
              </label>
              <Select
                menuShouldScrollIntoView={true}
                isMulti
                name="SkillID"
                value={selectedSkill}
                options={skillSetOptions}
                styles={customStyle}
                classNamePrefix="select"
                onChange={handleSkillFilter}
              />
            </div>
            <div className="col-md-2   px-2 ">
              <label class="form-label me-2">Type</label>
              <Select
                name="Type"
                onChange={(selected) => setTypeVlaue2(selected)}
                value={typeValue2}
                class="form-control "
                options={typeOptions}
              />
            </div>


            <div className="col-md-7 px-2 float-end">
              <div
                type="button"
                size="small"
                className="custom-btn mt-2  float-end"
                onClick={handleGetData}
              >
                Get Data
              </div>
              <div
                type="button"
                size="small"
                className="custom-btn mt-2  float-end  me-2"
                onClick={(e) => handleSubmit(e)}
              >
                {submitLoading ? <FaSpinner className="sm-spinner" /> : `Submit`}
              </div>
            </div>
          </div>
          {typeValue.value === 1 ?
            <div className="row">
              <Dynamic_PR_table
                data={employeeSelectionList}
                selectedResource={selectedResources}
                columns={columns} // Use dynamically computed columns
                defaultColumns={defaultColumns}
                itemsPerPage={10}
                searchTerm={searchTerm}
                isRequiredStatus={true}
                isApiStatus={apiStatus}
                setSearchTerm={setSearchTerm}
                showIcon1={true}
                showIcon2={false}
                showIcon3={false}
                isFilterRequired={false}
                showIcon4={true}
                showIcon5={false}
                isActionRequired={false}
                isCheckBoxRequired={true}
                selectAllChecked={selectAllChecked}
                handleCheckboxChange={handleCheckboxChange}
                handleSelectAllChange={handleSelectAllChange}
                icons={{
                  Icon1: <i className="bi bi-pencil-square icons"></i>,
                  Icon2: <i className="bi bi-trash-fill icons"></i>,
                  // Icon2Text: "Create Employee",
                  Icon3: <i className="bi bi-eye-fill icons"></i>,
                  Icon4: <i className="bi bi-person-plus icons"></i>,
                }}
              />
            </div> :
            <div className="row ">
              <Dynamic_PR_table
                data={employeeSelectionList}
                selectedResource={selectedResources}
                columns={ContratorColumns} // Use dynamically computed columns
                defaultColumns={defaultContratorColumns}
                itemsPerPage={10}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showIcon1={true}
                showIcon2={false}
                isRequiredStatus={true}
                isApiStatus={apiStatus}
                showIcon3={false}
                isFilterRequired={false}
                showIcon4={true}
                showIcon5={false}
                isActionRequired={false}
                isCheckBoxRequired={true}
                selectAllChecked={selectAllChecked}
                handleCheckboxChange={handleCheckboxChange}
                handleSelectAllChange={handleSelectAllChange}
                icons={{
                  Icon1: <i className="bi bi-pencil-square icons"></i>,
                  Icon2: <i className="bi bi-trash-fill icons"></i>,
                  // Icon2Text: "Create Employee",
                  Icon3: <i className="bi bi-eye-fill icons"></i>,
                  Icon4: <i className="bi bi-person-plus icons"></i>,
                }}
              />
            </div>}
        </div>
      </div>
    </>
  );
};

export default EmployeesSelection;
